module.exports = __webpack_public_path__ + "media/images/icons/SVG/010-3443c64b5dcef3e7335bfdceaaa1c9c3.svg";